import { BaseService } from "@/api/services/baseService";
import request from "@/api";
import { confirmable } from "@/utils/decorator/confirmable";
import type { Advert, AdvertVo } from "@zhihaoscm/entity";
import { type Page } from "@zhihaoscm/entity";
import type { AdvertForm } from "@/entity/manageCenter/Advert";

interface IOptionsSearch {
    /**
     * 页码
     */
    page: number;
    /**
     * 每页条数
     */
    size: number;
    /**
     * 标题或编号
     */
    key?: string;
    /**
     * 开始时间
     */
    startTime?: string;
    /**
     * 结束时间
     */
    endTime?: string;
    /**
     * 排序关键字
     */
    sortKey?: string;
    /**
     * 排序顺序 asc desc
     */
    sortOrder?: string;
    /**
     * 分类：1：pc；2：小程序
     */
    classify?: number;
    /**
     * 广告类型（1：图片；2：文本）
     */
    type?: number;
    /**
     * 是否被使用
     */
    used?: boolean;
}

export class AdvertService extends BaseService<Advert, AdvertVo, unknown, unknown> {
    public async getAdvertDetail(id: string | number): Promise<AdvertVo> {
        const { data } = await this.service.get(`${this.path}/find/${id}`);
        return data;
    }
    @confirmable("是否提交")
    public async creatAdvert(advertForm: AdvertForm): Promise<AdvertVo> {
        const { data } = await this.service.post(`${this.path}`, advertForm);
        return data;
    }
    @confirmable("是否提交")
    public async editAdvert(id: string, advertForm: AdvertForm): Promise<AdvertVo> {
        const { data } = await this.service.put(`${this.path}/${id}`, advertForm);
        return data;
    }
    @confirmable("是否删除")
    public async deleteAdvert(id: number): Promise<AdvertVo> {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }

    /**
     * 广告页列表
     */
    public async getListOptions(params: IOptionsSearch): Promise<Page<AdvertVo>> {
        const res = await this.service.get(`${this.path}/paging`, {
            params
        });
        return res.data;
    }
}

export const advertService = new AdvertService("/dataService/admin/advert", request.service);
